import Layout from "@/layout/index.vue";

export default [
  // 投放管理
  {
    path: "/tfgl",
    name: "tfgl",
    component: Layout,
    redirect: "/media-expense-ratio",
    meta: {
      title: "投放管理",
    },
    children: [
      {
        path: "/media-expense-ratio",
        name: "mediaExpenseRatio",
        component: () => import("@/views/page/tfgl/mediaExpenseRatio.vue"),
        meta: {
          title: "媒体费用比例配置",
        },
      },
    ],
  },
  // 投放管理
  {
    path: "/mttf",
    name: "mttf",
    component: Layout,
    redirect: "/media-expense-ratio",
    meta: {
      title: "投放管理",
    },
    children: [
      {
        path: "/media_report",
        name: "mediaReport",
        component: () => import("@/views/page/mttf/MediaReport.vue"),
        meta: {
          title: "媒体报表",
        },
      },
      {
        path: "/mttf/zx-to-mofang",
        name: "mttfZxToMofang",
        component: () => import("@/views/mttf/pages/zx-to-mofang/index.vue"),
        meta: {
          title: "赠转魔方数据统计",
          newPage: true,
        },
      },
        {
            path: "/mttf/toufang-monitor",
            name: "mttfToufangMonitor",
            component: () => import("@/views/mttf/pages/toufang-monitor/index"),
            meta: {
                title: "投放业务监控看板",
                newPage: true,
            },
        },
      {
        path: "/mttf/media-account",
        name: "mttfMediaAccount",
        component: () => import("@/views/mttf/pages/media-account/index.vue"),
        meta: {
          title: "媒体账户管理",
          newPage: true,
        },
      },
      {
        path: "/mttf/finance-bill",
        name: "mttfFinanceBill",
        component: () => import("@/views/mttf/pages/finance-bill/index.vue"),
        meta: {
          title: "财务流水",
          newPage: true,
        },
      },
      {
        path: "/mttf/cash-consume",
        name: "mttfCashConsume",
        component: () => import("@/views/mttf/pages/cash-consume/index.vue"),
        meta: {
          title: "现金消耗",
          newPage: true,
          noCache: true
        },
      },
    ],
  },
]
